window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-Lustre"] = {
  "meta": {
    "appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#cfcfcf",
      "border_radius_px": 0,
      "border_scope": "image_text",
      "border_size": 0,
      "gradient_angle": 42,
      "gradient_color": "#ffffff",
      "image_radius_px": 0,
      "product_image_padding": 0,
      "shadow_size": 0,
      "text_behavior": "wrap_text",
      "text_color": "#000000",
      "text_size_desktop": 13,
      "text_size_mobile": 12,
      "text_style": "normal"
    },
    "selected_appearance": {
      "background_color": "#ffffff",
      "background_image": "",
      "background_image_style": "center",
      "border_color": "#12316f",
      "border_radius_px": 0,
      "border_scope": "image_text",
      "border_size": 0,
      "gradient_color": "#ffffff",
      "image_radius_px": 0,
      "product_image_padding": 0,
      "shadow_size": 0,
      "text_color": "#000000",
      "text_style": "normal",
      "text_size_mobile": 12,
      "text_size_desktop": 13
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "custom_html": "<span hidden data-lustre-colors></span><style>:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-img-wrap{--mgps-row-aspect:1 / 1!important;aspect-ratio:1 / 1!important;height:auto!important;min-height:0!important}:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-img-inner img{width:100%!important;height:100%!important;object-fit:contain!important;object-position:center!important}:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) img[src*=\"Lustre-View-All\"]{transform:none!important}:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-title{white-space:normal!important;overflow-wrap:normal!important;word-break:normal!important;transform:none!important;line-height:1.2!important}.mgps-row:has([data-lustre-colors]){display:none!important}.mgps-modal:has([data-lustre-colors]){align-items:center!important;justify-content:center!important;padding:16px!important;box-sizing:border-box!important}.mgps-modal:has([data-lustre-colors]) .mgps-modal__dialog{width:min(1100px,calc(100vw - 32px))!important;max-height:calc(100dvh - 32px)!important;margin:0!important}.mgps-modal:has([data-lustre-colors]) .mgps-modal__body{min-height:0!important;max-height:calc(100dvh - 100px)!important;overflow:auto!important;overscroll-behavior:contain}.mgps-modal:has([data-lustre-colors]) .mgps-thumb-row{justify-content:center!important}@media(max-width:749px){.mgps-modal:has([data-lustre-colors]){padding-inline:8px!important}.mgps-modal:has([data-lustre-colors]) .mgps-modal__dialog{width:calc(100vw - 16px)!important;max-width:calc(100vw - 16px)!important}:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-card-bottom{padding:6px 3px!important;min-height:38px!important;box-sizing:border-box!important}:is([data-mg-set=\"Colors-Lustre\"],[data-mg-set$=\"-lustre_colors\"],[id$=\"__lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-title{font-size:12px!important}}</style><style>:is([data-mg-set$=\"-lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-card-bottom{min-height:50px!important;padding:8px 4px 10px!important}:is([data-mg-set$=\"-lustre_colors\"],.mgps-modal:has([data-lustre-colors])) .mgps-thumb-block{border:0!important;box-shadow:none!important;background:white!important}@media(max-width:749px){[data-mg-set$=\"-lustre_colors\"] .mgps-card-bottom{min-height:42px!important;padding:6px 2px 8px!important}}</style>",
      "custom_max_width_px": "0",
      "custom_template_id": "mgps-custom-stained-glass-colors",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "fit_row": false,
      "heading": "",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "margin_bottom": 0,
      "margin_top": "0",
      "row_height": 0,
      "row_justify": "center",
      "subheading": "",
      "swatch_row": false,
      "swatches": [],
      "videos": []
    },
    {
      "block_type": "mg_row",
      "find_product_handle_contains": "",
      "fit_row": true,
      "heading": "<h2>Metallic Lustre colors</h2>",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "margin_bottom": 10,
      "margin_top": 0,
      "more_popup_text": "More",
      "padding_between_rows": 8,
      "padding_between_rows_desktop": 8,
      "padding_between_rows_mobile": 8,
      "product_handle_contains": "",
      "random_zoom_max": "0",
      "randomize_zoom_area": false,
      "row_display_type": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type_mobile": "scale_to_fit",
      "row_height": "0",
      "row_height_desktop": "0",
      "row_height_mobile": "0",
      "row_justify": "center",
      "subheading": "",
      "swatch_image_zoom": "100",
      "swatch_row": true,
      "swatch_vertical_justify": "fit_to_height",
      "swatches": [
        {
          "alt": "DecoArt® Gold Rush Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-gold-rush",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447008390,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-gold-rush",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush-swatch.png?v=1793397794&width=400",
          "title": "Gold Rush",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Champagne Ice Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-champagne-ice",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461446942854,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML04C-28-champagne-ice.png?v=1793397792&width=400",
          "product_url": "/products/metallic-lustre-champagne-ice",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML04C-28-champagne-ice-swatch.png?v=1793397794&width=400",
          "title": "Champagne Ice",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Burnished Brass Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-burnished-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447434374,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML18C-28-burnished-brass.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-burnished-brass",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML18C-28-burnished-brass-swatch.png?v=1793397794&width=400",
          "title": "Burnished Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Silver Spark Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-silver-spark",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447041158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML03C-28-silver-spark.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-silver-spark",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML03C-28-silver-spark-swatch.png?v=1793397794&width=400",
          "title": "Silver Spark",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® White Frost Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-white-frost",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447401606,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML16C-28-white-frost.png?v=1793397792&width=400",
          "product_url": "/products/metallic-lustre-white-frost",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML16C-28-white-frost-swatch.png?v=1793397793&width=400",
          "title": "White Frost",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Iced Espresso Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-iced-espresso",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447073926,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML06C-28-iced-espresso.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-iced-espresso",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML06C-28-iced-espresso-swatch.png?v=1793397794&width=400",
          "title": "Iced Espresso",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Rose Gold Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-rose-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447368838,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML15C-28-rose-gold.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-rose-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML15C-28-rose-gold-swatch.png?v=1793397794&width=400",
          "title": "Rose Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Radiant Red Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-radiant-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447172230,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML07C-28-radiant-red.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-radiant-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML07C-28-radiant-red-swatch.png?v=1793397794&width=400",
          "title": "Radiant Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Lavish Green Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-lavish-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447204998,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML10C-28-lavish-green.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-lavish-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML10C-28-lavish-green-swatch.png?v=1793397794&width=400",
          "title": "Lavish Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Brilliant Turquoise Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-brilliant-turquoise",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447270534,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML11C-28-brilliant-turquoise.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-brilliant-turquoise",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML11C-28-brilliant-turquoise-swatch.png?v=1793397794&width=400",
          "title": "Brilliant Turquoise",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Cosmic Blue Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-cosmic-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447336070,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML12C-28-cosmic-blue.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-cosmic-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML12C-28-cosmic-blue-swatch.png?v=1793397793&width=400",
          "title": "Cosmic Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Black Shimmer Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-black-shimmer",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447139462,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML05C-28-black-shimmer.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-black-shimmer",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML05C-28-black-shimmer-swatch.png?v=1793397793&width=400",
          "title": "Black Shimmer",
          "type": "product",
          "vjust": "center"
        }
      ],
      "swatches_per_row": 6,
      "swatches_per_row_desktop": 6,
      "swatches_per_row_mobile": 4,
      "videos": [
        {
          "alt": "DecoArt® Gold Rush Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-gold-rush",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447008390,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-gold-rush",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML02C-28-gold-rush-swatch.png?v=1793397794&width=400",
          "title": "Gold Rush",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Champagne Ice Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-champagne-ice",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461446942854,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML04C-28-champagne-ice.png?v=1793397792&width=400",
          "product_url": "/products/metallic-lustre-champagne-ice",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML04C-28-champagne-ice-swatch.png?v=1793397794&width=400",
          "title": "Champagne Ice",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Burnished Brass Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-burnished-brass",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447434374,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML18C-28-burnished-brass.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-burnished-brass",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML18C-28-burnished-brass-swatch.png?v=1793397794&width=400",
          "title": "Burnished Brass",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Silver Spark Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-silver-spark",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447041158,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML03C-28-silver-spark.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-silver-spark",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML03C-28-silver-spark-swatch.png?v=1793397794&width=400",
          "title": "Silver Spark",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® White Frost Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-white-frost",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447401606,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML16C-28-white-frost.png?v=1793397792&width=400",
          "product_url": "/products/metallic-lustre-white-frost",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML16C-28-white-frost-swatch.png?v=1793397793&width=400",
          "title": "White Frost",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Iced Espresso Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-iced-espresso",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447073926,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML06C-28-iced-espresso.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-iced-espresso",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML06C-28-iced-espresso-swatch.png?v=1793397794&width=400",
          "title": "Iced Espresso",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Rose Gold Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-rose-gold",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447368838,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML15C-28-rose-gold.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-rose-gold",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML15C-28-rose-gold-swatch.png?v=1793397794&width=400",
          "title": "Rose Gold",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Radiant Red Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-radiant-red",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447172230,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML07C-28-radiant-red.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-radiant-red",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML07C-28-radiant-red-swatch.png?v=1793397794&width=400",
          "title": "Radiant Red",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Lavish Green Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-lavish-green",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447204998,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML10C-28-lavish-green.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-lavish-green",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML10C-28-lavish-green-swatch.png?v=1793397794&width=400",
          "title": "Lavish Green",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Brilliant Turquoise Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-brilliant-turquoise",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447270534,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML11C-28-brilliant-turquoise.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-brilliant-turquoise",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML11C-28-brilliant-turquoise-swatch.png?v=1793397794&width=400",
          "title": "Brilliant Turquoise",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Cosmic Blue Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-cosmic-blue",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447336070,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML12C-28-cosmic-blue.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-cosmic-blue",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML12C-28-cosmic-blue-swatch.png?v=1793397793&width=400",
          "title": "Cosmic Blue",
          "type": "product",
          "vjust": "center"
        },
        {
          "alt": "DecoArt® Black Shimmer Metallic Lustre swatch",
          "available": false,
          "buttons_over_image": false,
          "cta": {
            "href": "/products/metallic-lustre-black-shimmer",
            "text": "Shop"
          },
          "desc_html": "",
          "html_desc": "",
          "learn_more_text": "",
          "margin_bottom": 0,
          "margin_top": 0,
          "open_set_key": "",
          "price": "$8.51",
          "price_num": 8.51,
          "product_id": 15461447139462,
          "product_image_id": 0,
          "product_image_scale": "100",
          "product_image_url": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML05C-28-black-shimmer.png?v=1793397793&width=400",
          "product_url": "/products/metallic-lustre-black-shimmer",
          "product_variant_id": 0,
          "scale": "100",
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "swatch_image_zoom": "100",
          "swatch_mode": true,
          "swatch_vertical_justify": "fit_to_height",
          "thumb_mode": "override",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/ML05C-28-black-shimmer-swatch.png?v=1793397793&width=400",
          "title": "Black Shimmer",
          "type": "product",
          "vjust": "center"
        }
      ]
    }
  ]
};
